import axios from 'axios';

const configuredApiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3000';
const apiRoot = configuredApiUrl.replace(/\/+$/, '');
const API_BASE_URL = apiRoot.endsWith('/api') ? apiRoot : `${apiRoot}/api`;

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Helper function for file uploads
export const uploadFile = async (url, formData, method = 'POST') => {
  const token = localStorage.getItem('adminToken');
  const config = {
    method: method.toLowerCase(),
    url: `${API_BASE_URL}${url}`,
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
      ...(token && { Authorization: `Bearer ${token}` }),
    },
  };
  return axios(config);
};

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('adminToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle response errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('adminToken');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
